/**
@ngdoc service
@name formFieldFactory
*/
(function() {
    'use strict';

    var formFieldFactory = function($timeout) {

        // unregister field from the form, so - for example - it's valid despite the field is invalid
        var formUnregister = function(field, form){ // field it's ngModelCtrl
        	form.$removeControl(field);
        }

        // register field into the form
        var formRegister = function(field, form){ // field it's ngModelCtrl
        	form.$addControl(field);
    		angular.forEach(field.$error, function(validity, validationToken) {
    			form.$setValidity(validationToken, !validity, field);
            });
        }

        // determines the field (as xms-validation can be applied on the parent container too)
    	var searchElementDOM = function(el){
    		var field;
    		if( typeof el.attr('name') !== "undefined") {
    			field = el; // directive set directly on the element
    		} else {
    			var child = angular.element( el[0].querySelector("[name]") );
    			if( child.length ) {
    				// the directive is set on the parent, so we need to get first child element name
    				field = child;
    			} else {
    				// name attribute not found
    				// console.warn("Name attribute not found. The field has to have name attribute specified.");
    				console.error("Missing name attribute on or inside element:")
    				console.info(el);
    				throw "Field's name attribute not found.";
    			}
    		}
    		return field;
    	}

    	// make dependantField touched, dirty and !pristine
        function triggerDependantFieldValidation( dependantField, timeout ) { // dependantField is ngModelCtrl
            // console.log("dependant field validation triggered!");
            timeout = angular.isDefined(timeout) ? timeout : 0;
            $timeout(
                function(){
                    if(dependantField.$pristine) {
                        dependantField.$setPristine(false);
                    }
                    if(!dependantField.$touched) {
                        dependantField.$setTouched(true);
                    }
                    if(!dependantField.$dirty) {
                        dependantField.$setDirty(true);
                    }
                }, timeout);
        }


        // We now return a public API for our service.
        return {
        	formRegister     				: formRegister,
        	formUnregister   				: formUnregister,
        	searchElementDOM 				: searchElementDOM,
        	triggerDependantFieldValidation : triggerDependantFieldValidation
        };
    }

    formFieldFactory.$inject = ['$timeout'];
    angular.module('app').factory('formFieldFactory', formFieldFactory);

}());